import React, { FC } from 'react';
import { ProductsHorizontalSlider } from '@components/molecules/horizontalSliders/ProductsHorizontalSlider';
import { SectionHeader, SectionHeaderProps } from '@components/molecules/SectionHeader';
import { ProductCard, ProductCardProps } from '@components/molecules/ProductCard';
import { Container } from '@components/atoms/Container';
import { useMediaQuery } from '@hooks/useMediaQuery';

export interface ProductsHighlightsProps extends Omit<SectionHeaderProps, 'title'> {
    title: string;
    products: ProductCardProps[];
}

const MAX_PRODUCTS = 4;

export const ProductsHighlights: FC<ProductsHighlightsProps> = ({ title, actionLabel, linkTo, products }) => {
    const pageSize = useMediaQuery();

    const seeMore = products.length >= MAX_PRODUCTS;

    return (
        <div data-testid="products-highlights">
            <Container>
                <SectionHeader
                    title={{ text: title }}
                    actionLabel={seeMore ? actionLabel : undefined}
                    linkTo={seeMore ? linkTo : undefined}
                />
            </Container>

            {/* list of products */}
            {['xs', 'sm', 'md'].includes(pageSize) ? (
                <ProductsHorizontalSlider products={products} />
            ) : (
                <Container>
                    <div className="row row-gap-4 pt-2">
                        {products.slice(0, MAX_PRODUCTS).map((product, index) => (
                            <div key={`product-${index}`} className="col-3">
                                <ProductCard {...product} />
                            </div>
                        ))}
                    </div>
                </Container>
            )}
        </div>
    );
};
